import { IonRippleEffect } from '@ionic/react';
import React from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useHistory } from 'react-router';

const BackButton = () => {
  const history = useHistory();
  const handleBack = () => {
    if (history.length > 1) {
      return history.goBack();
    }
    history.push('/');
  };
  return (
    <div
      className="size-full py-2 cursor-pointer bg-background flex items-center justify-center ion-activatable ripple-parent rectangle relative overflow-hidden rounded-xl"
      onClick={handleBack}
    >
      <IonRippleEffect />
      <span className="h-full w-auto aspect-square flex items-center justify-center">
        <IoArrowBackOutline size="100%" className="size-full text-primary" />
      </span>
    </div>
  );
};

export default BackButton;
